/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CertificateListPostRequest } from '../models/CertificateListPostRequest';
import type { CertificatesResponse } from '../models/CertificatesResponse';
import { request as __request } from '../core/request';

export class CertificateService {

    /**
     * @param requestBody
     * @returns CertificatesResponse Ok
     * @throws ApiError
     */
    public static async getCertificateList(
        requestBody: CertificateListPostRequest,
    ): Promise<CertificatesResponse> {
        const result = await __request({
            method: 'POST',
            path: `/certificate/list`,
            body: requestBody,
            errors: {
                400: `Validation Failed`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param certMinioId
     * @returns any Ok
     * @throws ApiError
     */
    public static async getCertificatePdf(
        certMinioId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'GET',
            path: `/certificate/pdf/${certMinioId}`,
            errors: {
                400: `Validation Failed`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

}